// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // API_ENDPOINT_ROOT : "http://127.0.0.1:8001/api"
  // API_ENDPOINT_ROOT : "http://127.0.0.1:8000/api"
  API_ENDPOINT_ROOT: "https://dev.warehouseback.onex.am/api", // dev version
  // API_ENDPOINT_ROOT: "https://stagingback.warehouse.onex.am/api", // staging version
  // API_ENDPOINT_ROOT: 'http://192.168.0.168:8080/api', // local version
  // API_ENDPOINT_ROOT: "https://warehouseback.onex.am/api",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
